// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3u3Eo","text":"styles_text__v_1Bn"};